import { APIResponse } from "@/types/api";
import http from "@/composables/api";
import { RequisitionItemPayload, RequisitionPayload, RequisitionResponse } from "@/types/interface/requisition";

async function create(payload: RequisitionItemPayload) {
  return await http.post<APIResponse<RequisitionResponse>>("requisition-item/create", payload);
}

async function checkExistingRequest(idVessel: number, idItem: number, idVariant?: number) {
  let url = `requisition-item/check-existing-request?vessel_id=${idVessel}&goods_id=${idItem}`;
  if (idVariant) url += `&variant_id=${idVariant}`;
  return await http.get<APIResponse<never>>(url);
}

export default {
  create,
  checkExistingRequest,
};